import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles({
  form: {
    width: "auto",
    marginTop: "20px",
    marginRight: "15px",
    marginLeft: "15px",
  },
  formControl: {
    padding: "8px",
    maxHeight: "48px",
    maxWidth: "331px",
  },
  menuItem: {
    "&:hover": {
      borderLeft: "4px solid #098B8B",
    },
  },
  dropdown: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: 40,
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    }
  },
  dropdownMultiple: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
});
